import React from 'react';
import { Bar, Line } from 'react-chartjs-2';

const DashboardChart = ({ title, type = 'bar', data, options }) => {
  return (
  <div className="chart-card">
    <span className="dashboard-chart-title"><b>{title}</b></span>
    <div className="dashboard-chart-visual" style={{ height: '350px', position: 'relative', padding: '16px 0 8px 0' }}>
      {type === 'bar' ? (
        <Bar data={data} options={options} />
      ) : (
        <Line data={data} options={options} />
      )}
    </div>
  </div>
  );
};

export default DashboardChart; 